import { UserRole } from '../types/auth.types';

/**
 * Same set as api/src/shared/constant/staff-portal.constant.ts (STAFF_PORTAL_ROLES).
 * Used only for /owner route access — does not change owner UI; staff use same shell until role dashboards exist.
 */
export const STAFF_PORTAL_ROLES: UserRole[] = [
  UserRole.OWNER,
  UserRole.SUPER_ADMIN,
  UserRole.DEPARTMENT_HEAD,
  UserRole.ADMIN,
  UserRole.SPECIALIST,
  UserRole.SUPPORT,
];

export function hasStaffPortalRole(roles: UserRole[] | undefined): boolean {
  if (!roles?.length) return false;
  return roles.some((r) => STAFF_PORTAL_ROLES.includes(r));
}
